import classNames from 'classnames';
import { ForwardedRef, MouseEventHandler, ReactNode } from 'react';

import { BasicButtonElement } from '../buttons/BasicButton';
import CardContainer, { CardContainerElement } from './CardContainer';

import styles from '../../styles/cards/hybrid-card.module.css';

type HybridCardElement =
    HTMLDivElement | BasicButtonElement | HTMLAnchorElement | HTMLLabelElement | HTMLSpanElement;

interface HybridCardProps {
    href?: string | null;
    thumbnail?: ReactNode | null;
    thumbnailRatio?: number | null;
    children?: ReactNode | null;
    inner?: ReactNode | null;
    brand?: BrandHandle | null;
    theme?: string | null;
    size?: string | null;
    isLabel?: boolean;
    labelFor?: string | null;
    className?: string | null;
    thumbnailClassName?: string | null;
    labelClassName?: string | null;
    onClick?: MouseEventHandler<BasicButtonElement> | null;
}
function HybridCard({
    href = null,
    thumbnail = null,
    thumbnailRatio = null,
    children = null,
    inner = null,
    brand = null,
    theme = null,
    size = null,
    isLabel = false,
    labelFor = null,
    className = null,
    thumbnailClassName = null,
    labelClassName = null,
    onClick = null,
    ref: containerRef = null,
}: HybridCardProps & { ref?: ForwardedRef<HybridCardElement> | null }) {
    const Element = href !== null || onClick !== null ? 'span' : 'div';
    const cardInner = (
        <>
            {thumbnail !== null ? (
                <Element
                    className={classNames([
                        styles.thumbnail,
                        {
                            [thumbnailClassName]: thumbnailClassName !== null,
                        },
                    ])}
                >
                    <div
                        className={styles.thumbnailShape}
                        style={{
                            paddingBottom:
                                thumbnailRatio !== null ? `${(1 / thumbnailRatio) * 100}%` : null,
                        }}
                    >
                        {thumbnail}
                    </div>
                </Element>
            ) : null}
            <Element
                className={classNames([
                    styles.label,
                    {
                        [labelClassName]: labelClassName !== null,
                    },
                ])}
            >
                {children}
            </Element>
            {inner}
        </>
    );
    return (
        <CardContainer
            href={href}
            onClick={onClick}
            isLabel={isLabel}
            labelFor={labelFor}
            brand={brand}
            presentation="hybrid"
            theme={theme}
            size={size}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            ref={containerRef as ForwardedRef<CardContainerElement>}
        >
            {cardInner}
        </CardContainer>
    );
}
export default HybridCard;
